import revive_payload_client_4sVQNw7RlN from "/home/node/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/node/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/node/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/node/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/node/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/node/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/node/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/node/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/node/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/node/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_8BKffvaEi5 from "/home/node/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.mjs";
import i18n_yfWm7jX06p from "/home/node/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_client_UYiXMU8ZyN from "/home/node/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_t2GMTTFnMT from "/home/node/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import plugin_PSbK9A48ZQ from "/home/node/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "/home/node/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/home/node/.nuxt/element-plus-injection.plugin.mjs";
import preload_tokens_images_5kID6SpOeI from "/home/node/plugins/preload-tokens-images.ts";
import _01_web3Modal_nCIyPT0opF from "/home/node/plugins/01.web3Modal.ts";
import _02_referralLinkHandler_nS3bpqT2dj from "/home/node/plugins/02.referralLinkHandler.ts";
import _03_socketConnections_client_oKCVAloIqp from "/home/node/plugins/03.socketConnections.client.ts";
import apexcharts_client_xo3MRJYPBX from "/home/node/plugins/apexcharts.client.js";
import api_GFfDXud5Cr from "/home/node/plugins/api.ts";
import deviceCheckSSR_vYXCXykNdb from "/home/node/plugins/deviceCheckSSR.ts";
import error_handler_kEP5FliEXj from "/home/node/plugins/error-handler.ts";
import helpers_client_Geb2gMzsac from "/home/node/plugins/helpers.client.ts";
import helpers_mgWmzbOuLB from "/home/node/plugins/helpers.ts";
import imageHelpers_sW5weOaHPB from "/home/node/plugins/imageHelpers.ts";
import initVolume_client_VPFwr5st3s from "/home/node/plugins/initVolume.client.ts";
import modalsAudioController_client_dRHmdF3XhW from "/home/node/plugins/modalsAudioController.client.ts";
import soundFadeController_client_aaLNiljIlF from "/home/node/plugins/soundFadeController.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_8BKffvaEi5,
  i18n_yfWm7jX06p,
  plugin_client_UYiXMU8ZyN,
  plugin_t2GMTTFnMT,
  plugin_PSbK9A48ZQ,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  preload_tokens_images_5kID6SpOeI,
  _01_web3Modal_nCIyPT0opF,
  _02_referralLinkHandler_nS3bpqT2dj,
  _03_socketConnections_client_oKCVAloIqp,
  apexcharts_client_xo3MRJYPBX,
  api_GFfDXud5Cr,
  deviceCheckSSR_vYXCXykNdb,
  error_handler_kEP5FliEXj,
  helpers_client_Geb2gMzsac,
  helpers_mgWmzbOuLB,
  imageHelpers_sW5weOaHPB,
  initVolume_client_VPFwr5st3s,
  modalsAudioController_client_dRHmdF3XhW,
  soundFadeController_client_aaLNiljIlF
]